import { useGetItemSearchSuggestionQuery } from "~/gql/queries/items.generated";

interface UseItemSearchSuggestionParams {
	search: string;
	skip: boolean;
}

const useItemSearchSuggestion = ({ search, skip }: UseItemSearchSuggestionParams): null | string => {
	const { currentData } = useGetItemSearchSuggestionQuery({ search }, { skip });
	return currentData?.itemSearchSuggestion ?? null;
};

export default useItemSearchSuggestion;
